import "./shared/styles/main.scss";
import {
  useLocation,
  useNavigate,
  matchRoutes,
  BrowserRouter,
  Routes,
  Route,
} from "react-router";
import React, { useEffect, Suspense } from "react";
import { setNavigator } from "./shared/services/NavigationService";
import { CookieConsent } from "./features/cookie-consent/CookieConsent";
import { useSSENotifications } from "./shared/hooks/useSSENotifications";
import { isDebugMode } from "./shared/utils/isDebugMode";
import Error502Page from "./pages/Errors/Error502Page/Error502Page";


function App({ routes }: { routes: { path: string, element: React.ReactNode }[] }) {
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Проверяем, существует ли маршрут для текущего пути
  //   const matchedRoutes = matchRoutes(routes, location.pathname);

  //   if (!matchedRoutes) {
  //     alert("Такой страницы не существует!");
  //     navigate(-1); // Возврат на предыдущую страницу
  //   }
  //   setNavigator(navigate);

  // }, [location.pathname, navigate]);

  const debugMode = isDebugMode();

  useSSENotifications();

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.element}
            />
          ))}

          {debugMode && <Route path="/502" element={<Error502Page />} />}
        </Routes>
      </Suspense>
      {debugMode && <CookieConsent />}
    </>
  );
}

export default App;
